import React from 'react';

interface CheckIconProps extends React.SVGProps<SVGSVGElement> {
    title?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({ title, ...props }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={2} 
    stroke="currentColor" 
    {...props}
  >
    {title && <title>{title}</title>}
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

export default CheckIcon;